/**
 *   Created by Arif Topcu in 2018
 */
import React, {useCallback} from 'react';
import Input from "@ls/react-input";
import {selectSelectedMinAccWeight} from 'state/selections/selectors';
import SelectionState from 'state/selections/SelectionState';
import {setMinAccWeight} from 'state/selections/actions';
import {useDispatch, useSelector} from 'react-redux';

const MinAccWeightInput = (props) => {
  const dispatch = useDispatch();
  const value = useSelector(selectSelectedMinAccWeight(SelectionState.UNCOMMITTED));
  const onChange = useCallback((val) => {
    dispatch(setMinAccWeight(val?.length ? Number(val) : null));
  }, [dispatch]);

  return (
    <Input
      label="Min. Account Weight (%):"
      placeholder="Default"
      value={value ?? ''}
      size="S"
      onChange={onChange}
      variation={2}
      type="number"
      min={0}
      max={100}
      step={0.01}
    />
  );
};

export default MinAccWeightInput;
